export const config = {
  streamerName: "미네르 Mineru",
  chzzkChannelUrl:
    "https://chzzk.naver.com/live/aa6e91dc838cdf50996ffdb86f5854be",
  commandPrefix: "!신청",
  commandFormat: "{prefix} {requestCode}",
  accentColor: "#8b5cf6",
  notice:
    "처음 곡 목록을 불러오는데 조금 오래 걸릴 수 있습니다. 조금만 기다려 주세요!",
  songsApiUrl:
    "https://script.google.com/macros/s/AKfycby6V4Nz0PEcVxM4NvaY48Hr1Q6dQTH22kZq97oFm3MLSLVFGC-ax8NcknFj8KPNBBmzzQ/exec",
}

export function buildRequestCommand(requestCode: string): string {
  return config.commandFormat
    .replace("{prefix}", config.commandPrefix)
    .replace("{requestCode}", requestCode)
}
